import { Component, OnInit, ViewChild } from "@angular/core";
import { TutorialService } from "../../../../auth/service/tutorial.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ItutorialSingle } from "app/auth/models/tutorial-interface";

@Component({
  selector: "app-tutorial-video",
  templateUrl: "./tutorial-video.component.html",
  styleUrls: ["./tutorial-video.component.scss"],
})
export class TutorialVideoComponent implements OnInit {
  @ViewChild("tutorialModal") tutorialModal;

  public currentVideo: ItutorialSingle;

  constructor(
    public _tutorialService: TutorialService,
    private _modalService: NgbModal,
  ) {}

  async ngOnInit() {
    if (this._tutorialService.force_open_modal) {
      await this.openModal();
    }
  }

  async openModal() {
    this.currentVideo = await this._tutorialService.getTutorial(this._tutorialService.video_to_play);
    this._modalService.open(this.tutorialModal, {
      size: "lg",
      centered: true,
      backdrop: false,
      keyboard: false,
    });
  }

  async modalClose() {
    this._tutorialService.force_open_modal = false;
    // se non rimetto il video to play a zero mi rimane il bottone
    this._tutorialService.video_to_play = "";
  }
}
